var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventoryTotalProductItemsCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.24 17.5805H30.84L27.46 14.2005C27.19 13.9305 26.75 13.9305 26.47 14.2005C26.2 14.4705 26.2 14.9105 26.47 15.1905L28.86 17.5805H19.14L21.53 15.1905C21.8 14.9205 21.8 14.4805 21.53 14.2005C21.26 13.9305 20.82 13.9305 20.54 14.2005L17.17 17.5805H16.77C15.87 17.5805 14 17.5805 14 20.1405C14 21.1105 14.2 21.7505 14.62 22.1705C14.86 22.4205 15.15 22.5505 15.46 22.6205C15.75 22.6905 16.06 22.7005 16.36 22.7005H31.64C31.95 22.7005 32.24 22.6805 32.52 22.6205C33.36 22.4205 34 21.8205 34 20.1405C34 17.5805 32.13 17.5805 31.24 17.5805Z",
    fill: "#A4A7AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.05 24H16.87C16.25 24 15.78 24.55 15.88 25.16L16.72 30.3C17 32.02 17.75 34 21.08 34H26.69C30.06 34 30.66 32.31 31.02 30.42L32.03 25.19C32.15 24.57 31.68 24 31.05 24ZM24 31.5C21.66 31.5 19.75 29.59 19.75 27.25C19.75 26.84 20.09 26.5 20.5 26.5C20.91 26.5 21.25 26.84 21.25 27.25C21.25 28.77 22.48 30 24 30C25.52 30 26.75 28.77 26.75 27.25C26.75 26.84 27.09 26.5 27.5 26.5C27.91 26.5 28.25 26.84 28.25 27.25C28.25 29.59 26.34 31.5 24 31.5Z",
    fill: "#A4A7AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryTotalProductItemsCardIcon);
export default __webpack_public_path__ + "static/media/inventory-total-product-items-card-icon.d9ff867ac3c075bf12c44f772070f0ad.svg";
export { ForwardRef as ReactComponent };